// extracted by mini-css-extract-plugin
module.exports = {"pclTagline":"style_pclTagline__0yNdA","pbiHeading":"style_pbiHeading__MfMY8"};